import React from 'react'
import styles from './createStepSeries.module.sass'
import StepSeriesInfo from './StepSeriesInfo'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

const CreateStepSeries = ({isChanged, setIsChanged}) => {
    return (
        <>
            <ToastContainer />
            <div className={styles.row}>
                <div className={styles.col}>
                    <StepSeriesInfo isChanged={isChanged} setIsChanged={setIsChanged} className={styles.card}/>
                </div>
            </div>
        </>
    )
}

export default CreateStepSeries